<template>
  <div>
    <el-upload
      class="upload-file"
      action=""
      multiple
      :http-request="(file) => inner_handle_file_upload(file)"
      :on-remove="(file) => inner_handle_file_remove(file)"
      :show-file-list="true"
      :file-list="upload_file_list"
      :accept="accept_file_type"
      :before-upload="(file) => inner_check_file_type_before_upload(file)"
    >
      <el-button slot="trigger" size="small" type="primary">選擇檔案</el-button>
      <div slot="tip" class="el-upload__tip">檔案格式{{accept_file_type}}，上傳檔案大小限制為1MB。圖檔尺寸建議大於1024*768。</div>
    </el-upload>

    <div v-if="has_image">
      <AlreadyUploadList
        :article_index="article_index"
        :already_image_list="already_image_list"
        :upload_column_show="upload_cloumn_show"
        :handle_list_delete="handle_list_delete"
        :handle_list_edit="handle_list_edit"
        :can_edit_description="can_edit_description"
      />
    </div>
  </div>
</template>

<script>
import AlreadyUploadList from '@/components/backstage/UploadImageForm/AlreadyUploadList.vue'

export default {
  props: [
    'already_image_list', 'handle_file_upload', 'handle_file_remove', 
    'accept_file_type', 'upload_cloumn_show', 'file_list_name', 
    'handle_list_delete', 'handle_list_edit', 'article_index', 'check_file_type_before_upload',
    'can_edit_description'
  ],
  components: {
    AlreadyUploadList
  },
  data(){
    return{
      upload_file_list: [],
    }
  },
  created: async function () {
    console.log(this.already_image_list)
    console.log('(UploadImageFile): created functions')
  },
  computed: {
    has_image () {
      if (this.already_image_list!==null && typeof this.already_image_list!=='undefined' && this.already_image_list.length > 0) {
        return true
      }
      return false
    }
  },
  methods:{
    inner_check_file_type_before_upload(file) {
      console.log('inner_check_file_type_before_upload->file: ', file)
      if(this.check_file_type_before_upload) {
        console.log('this.upload_file_list: ', this.upload_file_list)
        if(this.check_file_type_before_upload(this.file_list_name, file)===false){
          return false
        }
        console.log('this.upload_file_list: ', this.upload_file_list)
      }
    },
    inner_handle_file_upload(file) {
      if(this.article_index!==null && typeof this.article_index!=='undefined') {
        this.handle_file_upload(this.file_list_name, file, this.article_index)
      }else {
        this.handle_file_upload(this.file_list_name, file)
      }
    },
    inner_handle_file_remove(file) {
      if(this.article_index!==null && typeof this.article_index!=='undefined') {
        this.handle_file_remove(this.file_list_name, file, this.article_index)
      }else {
        this.handle_file_remove(this.file_list_name, file)
      }
    },
  },
}
</script>

<style>

</style>
